export const enum SectorAlertTypes {
    rs_signal = 1,
    rs_direction = 2,
    bpi_signal = 3,
    bpi_direction = 4,
    bpi_status = 5,
    wk_30_signal = 6,
    wk_30_direction = 7,
    wk_10_signal = 8,
    wk_10_direction = 9
}